export default [
  {
    name: 'confirmInvoiceList',
    path: '/costInvoiceFolder/confirmInvoiceList',
    component: () => import (`@/views/cost/costInvoiceFolder/confirmInvoiceList.vue`),
    meta: {
      title: '发票夹上传确认'
    }
  },
  {
    name: 'invoiceFolderEdit',
    path: '/costInvoiceFolder/invoiceFolderEdit',
    component: () => import (`@/views/cost/costInvoiceFolder/invoiceFolderEdit.vue`),
    meta: {
      title: '发票夹编辑'
    }
  },
  {
    name: 'costEdit',
    path: '/costApplication/costEdit',
    component: () => import (`@/views/cost/costApplication/costEdit.vue`),
    meta: {
      title: '付款单编辑'
    }
  },
  {
    name: 'costEdit',
    path: '/cost/costInputAction_toCostInput.action',
    component: () => import ( /* webpackChunkName: "serveTable" */ `@/views/pub/pubIndex.vue`),
    meta: {
      title: '付款单编辑'
    }
  },
];
